import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { IconButton } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { NurseInShift } from "../../../../utils/models";
import { InHouseTooltip } from "../../../InHouseTooltip/InHouseTooltip";

export enum PunchCorrection {
	Remove = "remove",
	Add = "add",
}

type Props = {
	shift: NurseInShift;
	correction: PunchCorrection;
	onCorrect: (shift: NurseInShift) => void;
};

export const formatShiftWindow = (shift: NurseInShift): string =>
	`${shift.startTime.toFormat("h:mm a")}–${shift.endTime.toFormat("h:mm a")}${shift.location ? ` · ${shift.location}` : ""}`;

/** Removes a past shift from, or adds a past punch to, the schedule from a Punch Summary row. */
export const PunchCorrectionButton: FC<Props> = ({ shift, correction, onCorrect }) => {
	const { t } = useTranslation();
	const label = t(correction === PunchCorrection.Remove ? "punchSummary.removeFromSchedule" : "actual.addToSchedule.menuItem");
	return (
		<InHouseTooltip title={label}>
			<IconButton
				size="small"
				aria-label={label}
				data-testid={`action-center-${correction}-${shift.id}`}
				onClick={(event) => {
					event.stopPropagation();
					onCorrect(shift);
				}}
				sx={(theme) => ({
					color: theme.palette.text.secondary,
					"&:hover": { color: correction === PunchCorrection.Remove ? theme.palette.error.main : theme.palette.primary.main },
				})}
			>
				{correction === PunchCorrection.Remove ? <DeleteOutlineIcon fontSize="small" /> : <AddCircleOutlineIcon fontSize="small" />}
			</IconButton>
		</InHouseTooltip>
	);
};
